import React from 'react';
export var AddColLeftIcon = function AddColLeftIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    transform: "matrix(0 -1 1 0 0 24)",
    fill: "none",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "18",
    width: "12",
    height: "3",
    rx: "0.5",
    transform: "rotate(-90 12 18)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "18",
    width: "12",
    height: "3",
    rx: "0.5",
    transform: "rotate(-90 16 18)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11H5.99C5.72652 11.0026 5.47473 11.1092 5.28935 11.2964C5.10397 11.4837 4.99999 11.7365 5 12C5 12.556 5.444 13 5.99 13H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V13H10.01C10.2735 12.9974 10.5253 12.8908 10.7107 12.7036C10.896 12.5163 11 12.2635 11 12C11 11.444 10.556 11 10.01 11H9V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V11Z",
    fill: "currentColor"
  }));
};